module.exports = ['$rootScope', '$timeout', '$window', '$animate', function ($rootScope, $timeout, $window, $animate) {
    return {
        restrict: 'AC',
        scope: true,
        controller: [function(){

        }],
        link: function ($scope, $element, attrs) {


            $element.addClass("pd-calendar");

            $scope.isHoveredDay = function (day) {
                return $scope.hoveredDay == day;
            };

            $scope.setHoveredDay = function (day) {
                $scope.hoveredDay = day;
            };

            $scope.isToday = function (day) {
                var date = moment(day.year + "-" + day.month + "-" + day.day, $rootScope.dateFormat.moment_url);
                return moment().isSame(date, "day");
            };

            var rightAlignedDays = ['thu', 'fri', 'sat'];
            var centerAlignedDays = ['tue', 'wed'];

            $scope.isRightAligned = function (day) {
                return rightAlignedDays.indexOf(day.weekday) != -1;
            };

            $scope.isCenterAligned = function (day) {
                return centerAlignedDays.indexOf(day.weekday) != -1;
            };

            $scope.$on("calendar-resize", function () {
                $timeout(updateSize);
            });

            var body = $('body')[0];
            $scope.$watch(() => {
                return body.className
            }, (newClass, oldClass) => {
                $scope.$broadcast("calendar-resize");
            });

            var resizeTimer;
            var oldval;

            angular.element($window).bind('resize', function () {

                var newval = angular.element($window).width() + angular.element($window).height();

                if (newval != oldval) {

                    if (angular.isDefined(resizeTimer)) {
                        $timeout.cancel(resizeTimer);
                    }

                    resizeTimer = $timeout(function () {
                        $scope.$broadcast("calendar-resize");
                    }, 300);
                }

                oldval = newval;
            });

            function updateSize() {
                $element.find('.day').removeAttr("style");
                $timeout(function () {
                    var trs = $element.find('.week');
                    trs.each(function (tr_index, tr) {
                        var trHeight = 0;
                        tr = angular.element(tr);
                        var tds = tr.find('.day-cell');
                        tds.each(function (td_index, td) {
                            td = angular.element(td);

                            var height = td.height();
                            var hasDay = td.find('.day').length > 0;

                            if (trHeight < height && hasDay) {
                                trHeight = height;
                            }
                        });
                        tds.find('.day').height(trHeight);
                    });
                });
            }
        }
    };
}];